import { AppLoader } from '@/shared/components/ui/AppLoader'

export function BootScreen() {
  return <AppLoader label="" fullScreen />
}
